import React, { FC, useState } from 'react';
//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { isSuccess } from 'utils/responseStatus';
import { useDeleteEmployeeSalaryAdjustmentsDetailMutation } from 'bus/employeeSalaryAdjustments/employeeSalaryAdjustments';

type Props = {
    id: number | null;
    visible: boolean;
    changeVisible: (visible: boolean) => void
    refresh: () => void
}

const DeleteModal: FC<Props> = ({
    changeVisible,
    id,
    refresh,
    visible
}) => {
    const [deleteDetail, { isLoading }] = useDeleteEmployeeSalaryAdjustmentsDetailMutation();

    const handleSubmit = async (e: any) => {
        e.preventDefault && e.preventDefault()
        deleteDetail({ id: id! }).then((res: any) => {
            if (isSuccess(res)) {
                refresh();
                changeVisible(false);
            }
        });
    }

    return (
        <div>
            <Popup
                visible={visible}
                onHiding={() => changeVisible(false)}
                dragEnabled={true}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Подтвердите действие"
                width={400}
                height={160}
            >
                <div className="modal-block">
                    <form onSubmit={handleSubmit}>
                        <div className="modal-block__content">
                            Вы действительно хотите удалить?
                        </div>

                        <ModalFooter
                            useSubmitBehavior={false}
                            handleSubmit={handleSubmit}
                            hideModal={() => changeVisible(false)}
                            textConfirm="Удалить"
                            typeConfirm="danger"
                            disabledSubmit={isLoading}
                        />
                    </form>
                </div>
            </Popup>
        </div>
    )
}

export default DeleteModal;